import React from "react";
import '../Constants';
import {GAME_STATE_PLAYING, GAME_STATE_WIN, GAME_STATE_DRAW} from "../Constants";

const Header = ({currentPlayer, winPlayer, gameState}) => {
    const renderLabel = () => {
        switch(gameState) {
            case GAME_STATE_PLAYING:
                return <div>Player {currentPlayer} Turn</div>;
            case GAME_STATE_WIN:
                return <div>Player {winPlayer} Win</div>;
            case GAME_STATE_DRAW:
                return <div>Game is Draw</div>;
            default:
        }
    }

    return ( <div className="panel header">
        <div className="header-text">{renderLabel()}</div>
    </div>
    )
}

export default Header;